module.exports = __webpack_public_path__ + "static/media/EZYCOMP.f4bd43b6.jpg";